import type { RouteRecordRaw } from 'vue-router';

export const companyAIRoutes = [
  {
    path: '/admin/company-ai-context',
    name: 'admin-company-ai-context',
    component: () => import('@/views/admin/companyAIContext/index.vue'),
    meta: {
      title: 'Şirket AI Bağlamı',
      requiresAuth: true,
      hideNavbar: false,
      requiredPermissions: ['COMPANY_AI_GLOSSARY']
    }
  }
] satisfies RouteRecordRaw[];
